import filter from 'lodash/filter';
import first from 'lodash/first';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import some from 'lodash/some';
import startsWith from 'lodash/startsWith';

import loglevel from 'loglevel';

const saveReducer = (state = {}, action)=> {

  switch (action.type) {
  
  case 'PEND_SAVE': {
    return {
      ...state,
      [`pending-${action.id}`]: {
        descriptor: action.descriptor,
        data: action.data ?
            [ ...get(state, `pending-${action.id}.data`, []), action.data ]
          :
            get(state, `pending-${action.id}.data`, [])
      }
    };
  }

  case 'UNBLOCK_SAVE': {
    return omit(state, [`blocking-${action.id}`]);
  }

  case 'SEND_SAVE': {
    return {
      ...omit(state, [`pending-${action.id}`, `blocking-${action.id}`]),
      [`committing-${action.saveId}`]: { 
        id:action.id, 
        saveId: action.saveId, 
        descriptor: state[`pending-${action.id}`].descriptor 
      }
    }; 
  }

  case 'COMMIT_SAVE': {
    const id = state[`committing-${action.saveId}`].id;
    return {
      // Clear all record of the same on commit
      ...omit(state, [`committing-${action.saveId}`]),
      ...(action.blockNext ? { [`blocking-${id}`]: true } : {})
    };
  }

  case 'FAIL_SAVE': {
    return {
      ...omit(state, [`committing-${action.saveId}`]),
      // Keep a record of the failed save around
      failed: [ 
        ...(state.failed || []), 
        state[`committing-${action.saveId}`] 
      ]
    };
  }


  default:
    return state;

  }
};

export default saveReducer;

// This is useful code for debugging saving

// export default (state, action)=> {
//   const newState = saveReducer(state, action);
//   if (includes(['FAIL_SAVE','COMMIT_SAVE','SEND_SAVE','PEND_SAVE','UNBLOCK_SAVE'], action.type)) {
//     loglevel.setLevel('debug');
//     loglevel.debug('Action: ', action, 'New state:\n', newState);
//   }
//   return newState;
// };

export const getPendingSave = (state, id)=>
  (state[`pending-${id}`] || {}).data;

export const getSendingOrBlockingSave = (state, id)=>
  state[`blocking-${id}`] ||
  !isEmpty(
    filter(state, (value, key)=> startsWith(key, 'committing') && value.id === id)
  );
 
export const getSaveStatus = (state)=> {
  return (
    isEmpty(state.failed) ?
      some(keys(state), key => startsWith(key, 'pending')) ?
        'not saved'
      : some(keys(state), key => startsWith(key, 'committing')) ?
        'saving'
      :
        'saved'
      :
        'failed'
  );
};

export const getLastFailure = (state)=>
  first(state.failed);
